export default __webpack_public_path__ + "static/media/visa.19fa4b8a.svg";